// ProRes 2.5 — Profil arbeitsbezogener Ressourcen
// Selbsteinschätzungsbogen, 6-Punkt-Likert-Skala
// Quelle: Specs/ProRes_Profil arbeitsbezogener Ressourcen_2.5.xltm

const item = (key, text) => ({ key, text })

// 15 Skalen, 67 Items insgesamt. Pro Skala wird eine Seite gerendert.
export const SCALES = {
  // ── Personale Ressourcen ────────────────────────────────────────────────
  BSW: {
    code: 'BSW',
    label: 'Berufliche Selbstwirksamkeitserwartung',
    description: 'Vertrauen in die eigenen beruflichen Fähigkeiten und in das Erreichen selbstgesteckter Ziele.',
    items: [
      item('BSW1', 'Ich fühle mich gewappnet, auch mit unerwarteten Ereignissen umgehen zu können.'),
      item('BSW2', 'Ich kann Schwierigkeiten gelassen entgegen sehen, weil ich mich auf meine Fähigkeiten verlassen kann.'),
      item('BSW3', 'Ich glaube, dass ich Einfluss auf meine berufliche Laufbahn nehmen kann.'),
      item('BSW4', 'Ich bin mir sicher, ich werde zurechtkommen, was auch immer in meinem Berufsleben passiert.'),
      item('BSW5', 'Ich bin mir sicher, dass ich die beruflichen Ziele erreiche, die ich mir setze.'),
    ],
  },
  LOP: {
    code: 'LO-P',
    label: 'Lösungsorientierung – Planung',
    description: 'Fähigkeit, Probleme aus mehreren Perspektiven zu betrachten und vorausschauend zu planen.',
    items: [
      item('LOP1', 'Ich beschäftige mich mehr mit der Zukunft als mit der Vergangenheit.'),
      item('LOP2', 'In der Regel betrachte ich Probleme am Arbeitsplatz aus mehreren Perspektiven.'),
      item('LOP3', 'Schwierige Aufgaben in der Arbeit gehe ich an, indem ich mir verschiedene Handlungsmöglichkeiten überlege.'),
      item('LOP4', 'Es gelingt mir gut, mich im Voraus auf unvorhergesehene Situationen einzustellen und Ressourcen dafür einzuplanen.'),
      item('LOP5', 'Es gelingt mir gut, meine Planung anzupassen, wenn etwas dazwischengekommen ist.'),
    ],
  },
  LOU: {
    code: 'LO-U',
    label: 'Lösungsorientierung – Umsetzung',
    description: 'Fokus und Beharrlichkeit bei der schrittweisen Bearbeitung schwieriger Aufgaben.',
    items: [
      item('LOU1', 'Es gelingt mir gut, Probleme Schritt für Schritt zu lösen.'),
      item('LOU2', 'Auch wenn etwas anders kommt als geplant, verliere ich mein Ziel nicht aus den Augen.'),
      item('LOU3', 'Bei schwierigen Aufgaben am Arbeitsplatz behalte ich mein Ziel im Auge und lasse mich nicht vom Weg abbringen.'),
    ],
  },
  AK: {
    code: 'AK',
    label: 'Akzeptanz',
    description: 'Bereitschaft, das Unveränderbare anzunehmen, statt Energie an es zu verlieren.',
    items: [
      item('AK1', 'Wenn ich etwas nicht ändern kann, kann ich das gut akzeptieren.'),
      item('AK2', 'Ich halte mich nicht lange mit Dingen auf, die ich ohnehin nicht ändern kann.'),
    ],
  },
  RL: {
    code: 'RL',
    label: 'Reflexion & Lernfähigkeit',
    description: 'Lernen aus Erfahrungen, Neugierde und Humor im Umgang mit sich selbst.',
    items: [
      item('RL1', 'Ich reflektiere meine Erfahrungen und ziehe Lehren aus Erfolgen wie Niederlagen.'),
      item('RL2', 'Ich kann auch aus Rückschlägen wertvolle Erkenntnisse gewinnen.'),
      item('RL3', 'Ich bin neugierig, stelle Fragen und probiere gerne etwas Neues aus.'),
      item('RL4', 'Ich habe Humor und kann über mich und meine Erfahrungen lachen.'),
    ],
  },
  SF: {
    code: 'SF',
    label: 'Selbstfürsorge',
    description: 'Wahrnehmung der eigenen Grenzen, Abgrenzung und Umgang mit Druck und Kritik.',
    items: [
      item('SF1', 'Ich kann gut einschätzen, wieviel ich mir zumuten kann und wo meine Grenzen sind.'),
      item('SF2', 'Ich kann gegenüber anderen meine Erwartungen und Prioritäten gut kommunizieren.'),
      item('SF3', 'Ich kann bei meiner Arbeit auch mal „Nein sagen", wenn es sein muss.'),
      item('SF4', 'Ich weiß, wie ich mich beruhigen kann, wenn ich bei der Arbeit unter Druck stehe.'),
      item('SF5', 'Es gelingt mir gut, negatives Feedback zu meiner Arbeit nicht persönlich zu nehmen.'),
      item('SF6', 'Es gelingt mir gut, mich nicht allzu sehr zu ärgern, wenn ich einen Fehler gemacht habe.'),
      item('SF7', 'Ich kann mich von Problemen auf der Arbeit distanzieren, wenn es sein muss.'),
    ],
  },
  PU: {
    code: 'PU',
    label: 'Positive Umdeutung',
    description: 'Schwierigkeiten als Chance und Herausforderung interpretieren statt als Bedrohung.',
    items: [
      item('PU1', 'Ich bin davon überzeugt, dass die Konfrontation mit Problemen bei der Arbeit positiv zu meiner Entwicklung beiträgt.'),
      item('PU2', 'Eine schwierige Arbeitssituation betrachte ich als eine Gelegenheit, neue Fähigkeiten zu erlernen und diese weiterzuentwickeln.'),
      item('PU3', 'Berufliche Schwierigkeiten begreife ich in erster Linie als Herausforderung und nicht als Bedrohung.'),
      item('PU4', 'Berufliche Probleme betrachte ich als eine Gelegenheit, meine Fähigkeiten einzubringen.'),
    ],
  },

  // ── Organisationale Ressourcen ──────────────────────────────────────────
  MA: {
    code: 'MA',
    label: 'Motivierende Aufgabe',
    description: 'Sinnerleben, Abwechslung und Lernmöglichkeiten in der Tätigkeit selbst.',
    items: [
      item('MA1', 'Ich erlebe meine Arbeit als sinnvoll.'),
      item('MA2', 'Ich erlebe meine Arbeit als Teil eines größeren Ganzen.'),
      item('MA3', 'Meine Arbeit ist abwechslungsreich.'),
      item('MA4', 'Ich kann meine Fähigkeiten und Kenntnisse in meiner aktuellen Tätigkeit gut einsetzen.'),
      item('MA5', 'Ich kann bei meiner Arbeit immer wieder Neues dazulernen.'),
    ],
  },
  FLX: {
    code: 'FLX',
    label: 'Flexibilitätsspielraum',
    description: 'Anpassbarkeit von Arbeitsort und -zeit an persönliche Bedürfnisse.',
    items: [
      item('FLX1', 'Ich kann meinen Arbeitsort so anpassen, dass ich mich optimal auf meine Arbeit konzentrieren kann.'),
      item('FLX2', 'Ich kann meinen Arbeitsort so anpassen, dass ich meine Ansprüche an Arbeit und Privatleben optimal vereinbaren kann.'),
      item('FLX3', 'Ich kann die Arbeitszeit so einteilen, dass ich auch auf Unvorhergesehenes reagieren kann.'),
      item('FLX4', 'Ich kann meinen Arbeitsort so anpassen, dass ich mich optimal mit meinen Kollegen austauschen kann.'),
    ],
  },
  U: {
    code: 'U',
    label: 'Unterstützung',
    description: 'Verfügbare Hilfe und Zuhören durch Führungskraft und Kolleg:innen.',
    items: [
      item('U1', 'Bei meiner Arbeit kann ich auf die Unterstützung von meiner Führungskraft zurückgreifen.'),
      item('U2', 'Bei meiner Arbeit kann ich auf die Unterstützung von Kollegen zurückgreifen.'),
      item('U3', 'Meine Kollegen sind bereit, sich meine Arbeitsprobleme anzuhören.'),
      item('U4', 'Meine Führungskraft ist bereit, sich meine Arbeitsprobleme anzuhören.'),
      item('U5', 'Ich kann mich auf meine Kollegen verlassen, wenn bei der Arbeit Probleme auftauchen.'),
    ],
  },
  AU: {
    code: 'AU',
    label: 'Autonomie & Mitsprache',
    description: 'Selbstständige Einteilung der Arbeit und Beteiligung an Entscheidungen.',
    items: [
      item('AU1', 'Ich kann meine Arbeit selbstständig einteilen.'),
      item('AU2', 'Bei meiner Arbeit kann ich viele Entscheidungen selbst treffen.'),
      item('AU3', 'Ich kann entscheiden, wie ich meine Arbeit erledige.'),
      item('AU4', 'In meiner Arbeit habe ich viel Mitspracherecht, wie etwas gemacht wird.'),
      item('AU5', 'Wenn ich eine gute Idee habe, kann ich sie bei meinem Arbeitgeber auch verwirklichen.'),
      item('AU6', 'Bei wichtigen Dingen an meinem Arbeitsplatz kann ich mitreden und mitentscheiden.'),
    ],
  },
  RK: {
    code: 'RK',
    label: 'Rollenklarheit',
    description: 'Klarheit über Zuständigkeiten, Erwartungen und Ziele in der eigenen Rolle.',
    items: [
      item('RK1', 'Ich weiß, was in meinen Verantwortungsbereich fällt.'),
      item('RK2', 'Ich weiß, wer bei meiner Arbeit wofür zuständig ist.'),
      item('RK3', 'Ich weiß, was von mir bei meiner Arbeit erwartet wird.'),
      item('RK4', 'Bei meiner Arbeit weiß ich, was meine Ziele sind.'),
      item('RK5', 'Ich weiß, wer bei meiner Arbeit was entscheiden kann.'),
    ],
  },
  FB: {
    code: 'FB',
    label: 'Feedback',
    description: 'Hilfreiche Rückmeldung zu Ergebnissen und Wertschätzung für die eigene Arbeit.',
    items: [
      item('FB1', 'In meiner Arbeit bekomme ich hilfreiche Rückmeldung über die Gesamtergebnisse (z.B. von der Akquise bis zum Vertragsabschluss).'),
      item('FB2', 'Bei meiner Arbeit bekomme ich hilfreiche Rückmeldung von meiner Führungskraft.'),
      item('FB3', 'Bei meiner Arbeit bekomme ich hilfreiche Rückmeldung von Kollegen.'),
      item('FB4', 'Meine Führungskraft lässt mich wissen, wie gut ich meine Arbeit gemacht habe.'),
      item('FB5', 'Ich bekomme Wertschätzung für das, was ich tue.'),
    ],
  },
  W: {
    code: 'W',
    label: 'Wissensaufbau',
    description: 'Förderung von Erfahrungsaustausch, Qualifizierung und Informationszugang.',
    items: [
      item('W1', 'Bei meinem Arbeitgeber wird Erfahrungsaustausch gezielt gefördert.'),
      item('W2', 'Bei meiner Arbeit werden Wissensaufbau und Qualifizierung gezielt gefördert (z.B. durch Kurse, Schulungen).'),
      item('W3', 'Mir werden genug Informationen darüber bereitgestellt, wie meine Arbeit zu erledigen ist.'),
    ],
  },
  OV: {
    code: 'OV',
    label: 'Orientierung & Verlässlichkeit',
    description: 'Hilfsmittel, Vorlagen, ein roter Faden und verlässliche Vereinbarungen im Arbeitgeber.',
    items: [
      item('OV1', 'Für die Planung und Durchführung meiner Arbeit kann ich auf sinnvolle Hilfsmittel zurückgreifen (z.B. Checklisten, Leitfäden).'),
      item('OV2', 'Bei meiner Arbeit kann ich auf hilfreiche inhaltliche Vorlagen zurückgreifen (z.B. festgelegte Formulierungen, Briefvorlagen, vorgegebene Formate).'),
      item('OV3', 'Bei meinem Arbeitgeber kann man sich auf getroffene Vereinbarungen verlassen.'),
      item('OV4', 'Im Vorgehen meines Arbeitgebers erkenne ich einen roten Faden.'),
    ],
  },
}

export const GROUPS = [
  {
    id: 'personal',
    title: 'Personale Ressourcen',
    short: 'Person',
    hint: 'Beziehen Sie sich bei den nun folgenden Aussagen bitte auf Ihre Person.',
    scaleIds: ['BSW', 'LOP', 'LOU', 'AK', 'RL', 'SF', 'PU'],
  },
  {
    id: 'organisational',
    title: 'Organisationale Ressourcen',
    short: 'Organisation',
    hint: 'Die nun folgenden Aussagen sollten Sie auf Ihre Organisation beziehen.',
    scaleIds: ['MA', 'FLX', 'U', 'AU', 'RK', 'FB', 'W', 'OV'],
  },
]

// 6-Punkt-Likert
export const LIKERT = {
  values: [1, 2, 3, 4, 5, 6],
  labels: [
    'Trifft überhaupt nicht zu.',
    'Trifft kaum zu.',
    'Trifft eher nicht zu.',
    'Trifft eher zu.',
    'Trifft überwiegend zu.',
    'Trifft völlig zu.',
  ],
  short: ['überhaupt nicht', 'kaum', 'eher nicht', 'eher', 'überwiegend', 'völlig'],
}

// Step-Plan: 0 = welcome, 1 = demographics, dann pro Gruppe ein Hinweis-Step
// gefolgt von je einer Skala-Seite. Total 19 Steps.
const intro = (groupId) => ({ kind: 'intro', groupId })
const scale = (scaleId) => ({ kind: 'scale', scaleId })

const STEPS = [
  null, // 0 = welcome (separat)
  null, // 1 = demographics (separat)
  intro('personal'),
  scale('BSW'), scale('LOP'), scale('LOU'), scale('AK'), scale('RL'), scale('SF'), scale('PU'),
  intro('organisational'),
  scale('MA'), scale('FLX'), scale('U'), scale('AU'), scale('RK'), scale('FB'), scale('W'), scale('OV'),
]

export const PRORES = {
  slug: 'prores-2-5',
  name: 'ProRes – Profil arbeitsbezogener Ressourcen',
  version: '2.5',
  totalSteps: STEPS.length - 1, // 18 (Index 18 = OV)
  steps: STEPS,
  scales: SCALES,
  groups: GROUPS,
  likert: LIKERT,
  welcome: {
    headline: 'Herzlich Willkommen',
    subheadline: 'zum Profil arbeitsbezogener Ressourcen — ProRes',
    body: [
      'Der folgende Selbsteinschätzungsbogen soll Ihnen helfen zu erkunden, welche resilienzfördernden Ressourcen Sie bereits nutzen und wo Potenzial zum weiteren Ausbau dieser Ressourcen liegt.',
      'Er erfasst arbeitsbezogene Ressourcen, die sich einerseits auf Ihre Person, andererseits auf Ihren Arbeitgeber beziehen. Die Ergebnisse sind für Sie persönlich und dienen als Reflexionsgrundlage.',
      'Bitte bewerten Sie jede Aussage zügig und intuitiv auf der Skala von 1 („Trifft überhaupt nicht zu.") bis 6 („Trifft völlig zu."). Es gibt keine richtigen oder falschen Antworten.',
    ],
  },
}
